import {
  NumberInputProps as MantineNumberInputProps,
  NumberInput as MantineNumberInput,
} from '@mantine/core';

export type NumberInputProps = MantineNumberInputProps;

export const NumberInput = MantineNumberInput;

NumberInput.displayName = 'NumberInput';
